import style from "../rodingenerateboard.module.css";

const WaitingProgress = ({ percentage , queue }) => {
    const font=queue?'Queuing':'Generating'
    return (
        <div className={style.watingProgressWrapper}>
            <div className={style.progressInfo}>
                <span>{font}...</span>
                <span>{percentage}%</span>
            </div>
            <div className={style.progressBar}>
                <div className={style.progress} style={{ width: ` ${percentage}% ` }}></div>
            </div>
        </div>
    )
}



export { WaitingProgress }